import matter from "gray-matter";

import week_0_en from "./en/week-0.md";
import week_1_en from "./en/week-1.md";
import week_2_en from "./en/week-2.md";
import week_3_en from "./en/week-3.md";
import week_4_en from "./en/week-4.md";
import week_8_en from "./en/week-8.md";
import week_9_en from "./en/week-9.md";
import week_10_en from "./en/week-10.md";
import week_11_en from "./en/week-11.md";
import week_12_en from "./en/week-12.md";

import week_0_es from "./es/week-0.md";
import week_1_es from "./es/week-1.md";
import week_2_es from "./es/week-2.md";
import week_3_es from "./es/week-3.md";
import week_4_es from "./es/week-4.md";
import week_8_es from "./es/week-8.md";
import week_9_es from "./es/week-9.md";
import week_10_es from "./es/week-10.md";
import week_11_es from "./es/week-11.md";
import week_12_es from "./es/week-12.md";

const weekCollection = {
  en: [
    week_0_en,
    week_1_en,
    week_2_en,
    week_3_en,
    week_4_en,
    week_8_en,
    week_9_en,
    week_10_en,
    week_11_en,
    week_12_en,
  ],
  es: [
    week_0_es,
    week_1_es,
    week_2_es,
    week_3_es,
    week_4_es,
    week_8_es,
    week_9_es,
    week_10_es,
    week_11_es,
    week_12_es,
  ],
};

if (typeof window !== "undefined" && typeof window.Buffer === "undefined") {
  window.Buffer = {
    from: (value, encoding) => {
      if (encoding === "utf8" || encoding === "utf-8") {
        return new TextEncoder().encode(value);
      }
      return value;
    },
    isBuffer: (obj) => false,
  };
}

export function getBlogCollection(locale) {
  return weekCollection[locale]
    .map((file) => {
      return matter(file).data;
    })
    .filter((post) => post && Object.keys(post).length > 0);
}
